webpackJsonp([13],{

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(210)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(237),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-08fbca5e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_brands_svg_icons__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Team',
  data: function data() {
    return {
      href: {
        coworkGroup: 'https://t.me/coworkprogressbar',
        googleMapsProgressbar: 'https://goo.gl/maps/5Vgh7SUAL6N2',
        coworkerProgressbar: 'https://www.coworker.com/slovakia/bratislava/cowork-progressbar',
        facebookPageProgressbar: 'https://www.facebook.com/pg/progressbar/reviews/',
        instagram: 'https://www.instagram.com/progressbar_sk/'
      },
      socialsYangwao: [{ url: 'https://twitter.com/yangwao', title: 'Twitter', icon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_brands_svg_icons__["d" /* faTwitterSquare */] }, { url: 'https://www.linkedin.com/in/mnemcek/', title: 'Linkedin', icon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_brands_svg_icons__["h" /* faLinkedin */] }, { url: 'https://www.facebook.com/matej.wao.nemcek', title: 'Facebook', icon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_brands_svg_icons__["c" /* faFacebook */] }, { url: 'https://www.instagram.com/yangwao', title: 'Instagram', icon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_brands_svg_icons__["f" /* faInstagram */] }, { url: 'https://t.me/yangwao', title: 'Telegram', icon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_brands_svg_icons__["a" /* faTelegram */] }, { url: 'https://m.me/matej.wao.nemcek', title: 'Messenger', icon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_brands_svg_icons__["b" /* faFacebookMessenger */] }],
      socialsAnett: [{ url: 'https://twitter.com/anettrolikova', title: 'Twitter', icon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_brands_svg_icons__["d" /* faTwitterSquare */] }, { url: 'https://www.linkedin.com/in/anette-rolikova', title: 'Linkedin', icon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_brands_svg_icons__["h" /* faLinkedin */] }, { url: 'https://www.facebook.com/anett.rolikova', title: 'Facebook', icon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_brands_svg_icons__["c" /* faFacebook */] }, { url: 'https://www.instagram.com/anett.rolikova', title: 'Instagram', icon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_brands_svg_icons__["f" /* faInstagram */] }, { url: 'https://t.me/anettrolikova', title: 'Telegram', icon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_brands_svg_icons__["a" /* faTelegram */] }, { url: 'https://m.me/anett.rolikova', title: 'Messenger', icon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_brands_svg_icons__["b" /* faFacebookMessenger */] }]
    };
  }
});

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(99)(true);
// imports


// module
exports.push([module.i, "@media only screen and (max-width:768px){iframe[data-v-08fbca5e]{width:85vw}}iframe[data-v-08fbca5e]{width:100%}a.social-icon[data-v-08fbca5e]{color:hotpink}.social-icons[data-v-08fbca5e]{font-size:2.6em;padding:.1em}.social-icons[data-v-08fbca5e]:hover{cursor:pointer}", "", {"version":3,"sources":["/opt/build/repo/cowork-panel/src/components/Team.vue"],"names":[],"mappings":"AACA,yCACA,wBACQ,UAAY,CACnB,CACA,AACD,wBACM,UAAY,CACjB,AACD,+BACE,aAAe,CAChB,AACD,+BACE,gBAAiB,AACjB,YAAe,CAChB,AACD,qCACE,cAAgB,CACjB","file":"Team.vue","sourcesContent":["\n@media only screen and (max-width: 768px) {\niframe[data-v-08fbca5e] {\n        width: 85vw;\n}\n}\niframe[data-v-08fbca5e] {\n      width: 100%;\n}\na.social-icon[data-v-08fbca5e] {\n  color: hotpink;\n}\n.social-icons[data-v-08fbca5e] {\n  font-size: 2.6em;\n  padding: 0.1em;\n}\n.social-icons[data-v-08fbca5e]:hover {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(186);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(100)("5337c366", content, true, {});

/***/ }),

/***/ 237:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Team"
  }, [_c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-4 content has-text-white"
  }, [_c('img', {
    attrs: {
      "width": "320px",
      "src": "/static/img/team/matej_nemcek.jpg"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "has-text-white"
  }, [_vm._v("\n        Matej Nemček\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        Founder & Growth\n      ")]), _vm._v(" "), _vm._l((_vm.socialsYangwao.slice(0, 3)), function(item) {
    return _c('span', {
      key: item.url,
      staticClass: "social-icons"
    }, [_c('a', {
      staticClass: "social-icon",
      attrs: {
        "href": item.url,
        "target": "_blank",
        "rel": "noopener",
        "aria-hidden": "true"
      }
    }, [(item.icon) ? _c('font-awesome-icon', {
      attrs: {
        "icon": item.icon
      }
    }) : _vm._e()], 1)])
  }), _c('br'), _vm._v(" "), _vm._l((_vm.socialsYangwao.slice(3, 6)), function(item) {
    return _c('span', {
      key: item.url,
      staticClass: "social-icons"
    }, [_c('a', {
      staticClass: "social-icon",
      attrs: {
        "href": item.url,
        "target": "_blank",
        "rel": "noopener",
        "aria-hidden": "true"
      }
    }, [(item.icon) ? _c('font-awesome-icon', {
      attrs: {
        "icon": item.icon
      }
    }) : _vm._e()], 1)])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "column is-4 content has-text-white"
  }, [_c('img', {
    attrs: {
      "width": "320px",
      "src": "/static/img/team/anett_rolikova.jpg"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "has-text-white"
  }, [_vm._v("\n        Anett Rolikova\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        Events & Operations\n      ")]), _vm._v(" "), _vm._l((_vm.socialsAnett.slice(0, 3)), function(item) {
    return _c('span', {
      key: item.url,
      staticClass: "social-icons"
    }, [_c('a', {
      staticClass: "social-icon",
      attrs: {
        "href": item.url,
        "target": "_blank",
        "rel": "noopener",
        "aria-hidden": "true"
      }
    }, [(item.icon) ? _c('font-awesome-icon', {
      attrs: {
        "icon": item.icon
      }
    }) : _vm._e()], 1)])
  }), _c('br'), _vm._v(" "), _vm._l((_vm.socialsAnett.slice(3, 6)), function(item) {
    return _c('span', {
      key: item.url,
      staticClass: "social-icons"
    }, [_c('a', {
      staticClass: "social-icon",
      attrs: {
        "href": item.url,
        "target": "_blank",
        "rel": "noopener",
        "aria-hidden": "true"
      }
    }, [(item.icon) ? _c('font-awesome-icon', {
      attrs: {
        "icon": item.icon
      }
    }) : _vm._e()], 1)])
  })], 2)])])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/13.5825b7e6cdae15df85b4.js